import {Injectable} from '@angular/core';
import {Response, URLSearchParams, RequestOptions} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
// import {JobsOffer} from '../../models/jobs-offer';
import 'rxjs/add/operator/map';
// import {JobsOffersApplicant} from '../../models/jobs-offers-applicant'
// import { Subject } from 'rxjs/Subject';

@Injectable()
export class FormCompetenceService {

  private formCompetenceUrl: string = `${ environment.apiRoot }/competence/`;

  constructor(private http: HttpAuth) { }

  public getCompetences(): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    let options = new RequestOptions({search: params});

    return this.http.get(this.formCompetenceUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postInvite(listCompetence:any, jobId: any, userId: any): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = {job_id:jobId, user_id:userId, competences:listCompetence};

    let options = new RequestOptions({search: params});

    return this.http.post(this.formCompetenceUrl,body,options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/form-competence.service.ts